import {
  TrackingPageBlock,
  TrackingPageBlockType,
} from "./tracking-page-definition";

/**
 * Line-item property names a page opts into showing: an items block's custom
 * fields while it shows them, and every Custom HTML block's list. Properties
 * can hold shopper-entered text, so nothing else leaves the order.
 */
export function pageLineItemPropertyAllowlist(
  blocks: readonly TrackingPageBlock[] | undefined,
): string[] {
  const names = new Set<string>();
  for (const block of blocks ?? []) {
    const blockNames =
      block.type === TrackingPageBlockType.ITEMS_IN_FULFILLMENT
        ? block.showCustomFields
          ? block.customFields
          : undefined
        : block.type === TrackingPageBlockType.CUSTOM_HTML
          ? block.customFields
          : undefined;
    for (const name of blockNames ?? []) {
      names.add(name);
    }
  }
  return [...names];
}
